export const PRIORITIES = {
  LOW: 'low',
  NORMAL: 'normal',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical',
} as const;

export type PriorityType = (typeof PRIORITIES)[keyof typeof PRIORITIES];

export const PRIORITY_ORDER: PriorityType[] = [
  PRIORITIES.LOW,
  PRIORITIES.NORMAL,
  PRIORITIES.MEDIUM,
  PRIORITIES.HIGH,
  PRIORITIES.CRITICAL,
];

export const TRANSLATE_PRIORITIES = {
  [PRIORITIES.LOW]: 'низкий',
  [PRIORITIES.NORMAL]: 'нормальный',
  [PRIORITIES.MEDIUM]: 'средний',
  [PRIORITIES.HIGH]: 'высокий',
  [PRIORITIES.CRITICAL]: 'критический',
};

export const COLORS_BY_PRIORITY = {
  [PRIORITIES.LOW]: '#00ae46',
  [PRIORITIES.NORMAL]: '#dada0c',
  [PRIORITIES.MEDIUM]: '#e6aa03',
  [PRIORITIES.HIGH]: '#d0021b',
  [PRIORITIES.CRITICAL]: '#d0021b',
};

export const TICKET_STATUS_PLACEMENT = {
  TICKET_CARD: 'ticket_card', // в карточке тикета
  TICKET_STATUS_SELECTOR: 'ticket_status_selector', // в селекторе статуса в редакторе тикета
  FILTERS: 'filters', // в фильтрах
  TICKET_CARD_WITH_MANAGER: 'ticket_card_with_manager', // в карточке тикета с менеджером
};

export const STATUSES = {
  OPEN: 'open',
  IN_WORK: 'in_work',
  WAIT_FOR_CLIENT: 'wait_for_client',
  WAIT_FOR_OPERATOR: 'wait_for_operator',
  WAIT_FOR_SERVICE: 'wait_for_service',
  CLOSED: 'closed',
  PLANNED: 'planned',
} as const;

export const EXTRA_STATUSES = {
  CLOSED_BY_ORDER: 'closed_by_order',
  CLOSED_BY_REASON: 'closed_by_reason',
  CLOSE_ACTION: 'close_action',
};

export const TITLES = {
  [STATUSES.CLOSED]: 'Закрыт',
  [STATUSES.OPEN]: 'Неразобранное',
  [STATUSES.PLANNED]: 'Запланировано',
  [STATUSES.IN_WORK]: 'В работе',
  [STATUSES.WAIT_FOR_CLIENT]: 'Ожидаем ответа туриста',
  [STATUSES.WAIT_FOR_OPERATOR]: 'Ожидает ответа от ТО',
  [STATUSES.WAIT_FOR_SERVICE]: 'Требуется действие',
  [EXTRA_STATUSES.CLOSED_BY_ORDER]: 'Подобран',
  [EXTRA_STATUSES.CLOSED_BY_REASON]: 'Не подобран',
  [EXTRA_STATUSES.CLOSE_ACTION]: 'Закрыть тикет',
};

export const PRIORITIES_BY_STATUS = {
  [STATUSES.CLOSED]: PRIORITIES.LOW,
  [STATUSES.OPEN]: PRIORITIES.MEDIUM,
  [STATUSES.IN_WORK]: PRIORITIES.MEDIUM,
  [STATUSES.WAIT_FOR_CLIENT]: PRIORITIES.MEDIUM,
  [STATUSES.WAIT_FOR_OPERATOR]: PRIORITIES.MEDIUM,
  [STATUSES.WAIT_FOR_SERVICE]: PRIORITIES.HIGH,
  [STATUSES.PLANNED]: PRIORITIES.MEDIUM,
};

export const TIME_FORMAT = 'd MMM H:mm';
